import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

import Amplify from '@aws-amplify/auth';
import {CONFIG} from "./config";

const userPoolId = localStorage.getItem('amplify-user-pool-id')

if (userPoolId == CONFIG.amplifyExternal.Auth.userPoolId) Amplify.configure(CONFIG.amplifyExternal)
else Amplify.configure(CONFIG.amplifyADFS)

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
